import { Fragment, ReactElement } from 'react';
import CancellationDeathNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const CancellationDeathNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <CancellationDeathNotificationCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

CancellationDeathNotificationCivilStatusPage.displayName =
  'Cancellation Death Notification Page component';

export default CancellationDeathNotificationCivilStatusPage;
